import React from 'react'
import PropTypes from 'prop-types'
import { trimSpacesAndCommas, stringOrEmpty } from 'shared/helper'

const DEFAULT_SALUTATION_TEXT = "Hello"

const GreetingTitle = ({lead, config}) => {
  const name = stringOrEmpty(lead.name)
  const salutationText = config.salutation_text || DEFAULT_SALUTATION_TEXT
  const title = (lead.anon_guest || lead.group_user || !name)
    ? salutationText
    : trimSpacesAndCommas(`${salutationText} ${name}`)
  return <h1 className='greeting-title'>{title}</h1>
}

GreetingTitle.propTypes = {
  lead: PropTypes.object.isRequired,
  config: PropTypes.object.isRequired
}

export default GreetingTitle
